import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ApplianceListDiscStyles";
import Disc from "./Disc";

export default class DiscList extends Component {
  render() {
    return (
      <a href={this.props.href} className={css(styles.container)}>
        <div className={css(styles.discWrapper)}>
          <Disc {...this.props} />
        </div>
        <div className={css(styles.textContainer)}>
          <span className={css(styles.title)}>{this.props.title}</span>
          <span className={css(styles.subTitle)}>{this.props.subTitle}</span>
        </div>
        <div className={css(styles.arrow)}>&#xf105;</div>
      </a>
    );
  }
}
